import { customInstance } from "../../api-client/custom-instance";
import { logoutCreate } from "../../api-client/logout/logout";

// Set when a visitor enters the public read-only demo (POST /all/showcase-login/). The server
// enforces read-only regardless (main/showcase.py); this flag only drives the banner and hides
// the support chat, whose sign-in the server would refuse for the shared guest.
// index.html reads the same key, so keep the name in sync.
const SHOWCASE_FLAG = "showcaseGuest";

export function isShowcaseGuest(): boolean {
  try {
    return localStorage.getItem(SHOWCASE_FLAG) === "1";
  } catch {
    return false;
  }
}

export async function enterShowcase(): Promise<void> {
  await customInstance<{ detail: string }>({ url: "/all/showcase-login/", method: "POST" });
  try {
    localStorage.clear(); // drop any previous user's cached state
    localStorage.setItem(SHOWCASE_FLAG, "1");
  } catch {
    // storage blocked: the demo still works, just without the banner
  }
  window.location.assign("/app/map");
}

export async function exitShowcase(destination = "/home"): Promise<void> {
  try {
    localStorage.clear();
  } catch {
    // ignore storage errors
  }
  try {
    await logoutCreate();
  } catch (error) {
    console.error("Error leaving the demo:", error);
  }
  // No queryClient.clear() here: the full page load drops the cache anyway, and clearing it while
  // the app is still mounted re-renders NewHeader with no user (user.isAdmin) before unload.
  window.location.assign(destination);
}
